import { BadgeCheck, ExternalLink, XCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { api, patchJson } from "../api";
import type { ListingMatchReview } from "../types";

const money = (cents: number | null) => cents ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(cents / 100) : "Price not captured";

export function PriceMatchQueue() {
  const [reviews, setReviews] = useState<ListingMatchReview[]>([]);
  const [selectedId, setSelectedId] = useState("");
  const load = () => api<{ reviews: ListingMatchReview[] }>("/api/admin/price-match-reviews").then(({ reviews: rows }) => {
    setReviews(rows); setSelectedId((id) => rows.some((row) => row.id === id) ? id : rows[0]?.id ?? "");
  });
  useEffect(() => { load(); }, []);
  const selected = reviews.find((review) => review.id === selectedId);
  const decide = async (decision: "approved" | "rejected") => {
    if (!selected) return;
    await patchJson(`/api/admin/price-match-reviews/${selected.id}`, { decision });
    await load();
  };
  return <main className="admin-main"><header><div><h1>Price match review</h1><p>Resolve ambiguous builder-listing and permit addresses before a verified badge can appear.</p></div></header>
    <section className="admin-workspace price-review-workspace">
      <div className="lead-list"><p className="lead-total">{reviews.length} pending matches</p><div className="price-review-list">
        {reviews.map((review) => <button key={review.id} className={selectedId === review.id ? "selected" : ""} onClick={() => setSelectedId(review.id)}>
          <strong>{review.sourceAddress}</strong><span>{review.matchConfidence.replaceAll("_", " ")}</span><small>{money(review.priceCents)}</small>
        </button>)}
        {!reviews.length ? <div className="admin-empty"><BadgeCheck /><strong>Review queue is clear</strong><p>Exact matches verify automatically. Ambiguous units and sibling buildings appear here.</p></div> : null}
      </div></div>
      {selected ? <aside className="lead-detail price-review-detail"><h2>{selected.sourceAddress}</h2><a href={selected.sourceUrl} target="_blank" rel="noreferrer">Open builder source <ExternalLink /></a>
        <dl><div><dt>Proposed permit</dt><dd>{selected.permitAddress} {selected.zipCode}</dd></div><div><dt>Captured price</dt><dd>{money(selected.priceCents)}</dd></div><div><dt>Why review?</dt><dd>{selected.matchReason}</dd></div></dl>
        <p>Confirm the exact unit or building on the source page. Approval attaches all immutable observations for this listing to the permit.</p>
        <div className="lead-actions"><button className="button primary" onClick={() => decide("approved")}><BadgeCheck />Approve match</button><button className="button outline" onClick={() => decide("rejected")}><XCircle />Reject</button></div>
      </aside> : null}
    </section>
  </main>;
}
